export const BASE_AUTH_USER = 'user';
export const BASE_AUTH_TOKEN = 'token';

export enum OrderStatusesEnum {
  ALL = 'ALL',
  OFFERS = 'OFFERS',
  INDESIGN = 'INDESIGN',
}

export enum PROJECT_ACTION_GROUP_STATUS {
  PENDING = 'PENDING',
  REQUESTED = 'REQUESTED',
  CHECKED = 'CHECKED',
  APPROVED_WITHOUT_CHECK = 'APPROVED_WITHOUT_CHECK',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  FINISHED = 'FINISHED',
}

export enum VERDICT_ENUM {
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  PARTIALLY = 'PARTIALLY',
}
export enum PERMISSIONS_ENUM {
  VIEW_LANDS = 'VIEW_LANDS',
  VIEW_PROJECTS = 'VIEW_PROJECTS',
  VIEW_STATISTICS = 'VIEW_STATISTICS',
}

export enum InspectionReviewRateEnum {
  UNSATISFIED = 'UNSATISFIED',
  MEDIUM = 'MEDIUM',
  GOOD = 'GOOD',
  EXCELLENT = 'EXCELLENT',
}

export enum InspectionReviewerTypeEnum {
  FARMER = 'FARMER',
  MASTER = 'MASTER',
  INSPECTOR = 'INSPECTOR',
}

export const notSelected = [
  {
    label: 'all.contours',
    value: 'all',
  },
  {
    label: 'projected.contours',
    value: 'merged',
  },
  {
    label: 'undesigned.contours',
    value: 'unMerged',
  },
];
export const selected = [
  {
    label: 'projected.contours',
    value: 'merged',
  },
  {
    label: 'undesigned.contours',
    value: 'unMerged',
  },
  {
    label: 'selected.contours.for.the.project',
    value: 'selected',
  },
];

export const MONTHS = [
  {
    value: 'JANUARY',
    label: 'Yanvar',
  },
  {
    value: 'FEBRUARY',
    label: 'Fevral',
  },
  {
    value: 'MARCH',
    label: 'Mart',
  },
  {
    value: 'APRIL',
    label: 'Aprel',
  },
  {
    value: 'MAY',
    label: 'May',
  },
  {
    value: 'JUNE',
    label: 'Iyun',
  },
  {
    value: 'JULY',
    label: 'Iyul',
  },
  {
    value: 'AUGUST',
    label: 'Avgust',
  },
  {
    value: 'SEPTEMBER',
    label: 'Sentabr',
  },
  {
    value: 'OCTOBER',
    label: 'Oktabr',
  },
  {
    value: 'NOVEMBER',
    label: 'Noyabr',
  },
  {
    value: 'DECEMBER',
    label: 'Dekabr',
  },
];
export const YEAR = [
  {
    value: '2025',
    label: '2025',
  },
  {
    value: '2026',
    label: '2026',
  },
  {
    value: '2027',
    label: '2027',
  },
  {
    value: '2028',
    label: '2028',
  },
  {
    value: '2029',
    label: '2029',
  },
  {
    value: '2030',
    label: '2030',
  },
];

export const DIRECTION_CODES = [
  {
    value: '00',
    label: 'direction code 0',
  },
  {
    value: '01',
    label: 'direction code 1',
  },
  {
    value: '02',
    label: 'direction code 2',
  },
  {
    value: '03',
    label: 'direction code 3',
  },
  {
    value: '04',
    label: 'direction code 4',
  },
  {
    value: '05',
    label: 'direction code 5',
  },
  {
    value: '06',
    label: 'direction code 6',
  },
  {
    value: '07',
    label: 'direction code 7',
  },
  {
    value: '08',
    label: 'direction code 8',
  },
  {
    value: '10',
    label: 'direction code 9',
  },
  {
    value: '11',
    label: 'direction code 10',
  },
  {
    value: '12',
    label: 'direction code 11',
  },
  {
    value: '13',
    label: 'direction code 12',
  },
  {
    value: '14',
    label: 'direction code 13',
  },
  {
    value: '15',
    label: 'direction code 14',
  },
  {
    value: '16',
    label: 'direction code 15',
  },
  {
    value: '17',
    label: 'direction code 16',
  },
  {
    value: '18',
    label: 'direction code 17',
  },
  {
    value: '19',
    label: 'direction code 18',
  },
  {
    value: '20',
    label: 'direction code 19',
  },
  {
    value: '25',
    label: 'direction code 20',
  },
  {
    value: '27',
    label: 'direction code 21',
  },
  {
    value: '26',
    label: 'direction code 21',
  },
];
